export default "__VITE_ASSET__gJIuO2Ph__"